<mat-icon class="sign-status-icon material-icons-outlined" [class]="'sign-status-icon' + colorModifier()">
  report
</mat-icon>
